import React, {Fragment, useState} from "react";
import SnackbarUtil from '@/utils/SnackbarUtil';
import {useTranslation} from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  IconButton,
} from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import EmployeeService from '@/services/hr/EmployeeService'
import {ReactComponent as EnableIcon} from '@/assets/person/Enable.svg';
import {ReactComponent as DisableIcon} from '@/assets/person/Disable.svg';

const appAccessStyle = {
  '& .MuiPaper-root': {width: '500px', top: '-10vh'},
  '.MuiDialog-paper': {maxWidth: '60vw'},
};

export interface EmailProps {
  employees: any,
  enable: boolean,
  reloadTable: any,
  onComplete: () => void;
}

const AppAccess = (props: EmailProps) => {
  const [info, setInfo] = useState<boolean>(false)
  const {t} = useTranslation()
  const [loading, setLoading] = React.useState(false);
  const toggleDrawer =
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (props.employees.length === 0) {
        SnackbarUtil.error(
          t("common.Select employee first."),
          {anchorOrigin: {vertical: 'top', horizontal: 'center'}}
        );
        return;
      }
      setInfo(true);
    };
  const handleClose = () => {
    setInfo(false);
  };
  const changeEmployeeAccess = () => {
    setLoading(true)
    EmployeeService.appAccess(props.enable, {"emp_list": props.employees}).then(
      (result) => {
        if (result.data?.code == 'UASE0006') {
          SnackbarUtil.error(
            t("common.There has invalid format in email data."),
            {anchorOrigin: {vertical: "top", horizontal: "center"}}
          );
          setInfo(false)
          setLoading(false)
          return
        }
        const count = result.data?.data?.count
        if (!props.enable) {
          SnackbarUtil.success(
            t("common.Disable employees app access successful.", {value: count}),
            {anchorOrigin: {vertical: "top", horizontal: "center"}}
          );
        } else {
          SnackbarUtil.success(
            t("common.Enable employees app access successful.", {value: count}),
            {anchorOrigin: {vertical: "top", horizontal: "center"}}
          );
        }

        setInfo(false)
        setLoading(false)

        if (props.reloadTable) {
          setTimeout(() => {
            props.onComplete?.();
            props.reloadTable();
          }, 1000);
        }
      },
      (error) => {
        setLoading(false);
        setInfo(false);
        console.log("Employee app access error:::", error.toString())
        // SnackbarUtil.error(error.toString(), {
        //   anchorOrigin: {vertical: "top", horizontal: "center"},
        // });
      }
    );
  };

  return (
    <Fragment>
      <Grid item={true} onClick={toggleDrawer}>
        <Grid onClick={() => {
          toggleDrawer
        }}>
          <Grid sx={{display: "flex"}}>
            <Grid sx={{marginLeft: "0px"}}>{props.enable ? <EnableIcon/> : <DisableIcon/>}</Grid>
            <Grid sx={{
              color: "rgb(117, 130, 138)",
              fontSize: "14px !important",
              textTransform: 'none !important',
              fontFamily: 'Roboto, Helvetica, Arial, sans-serif !important',
              fontWeight: 'normal',
              lineHeight: 1.5,
              marginLeft: "4px",
            }}>{props.enable ? t("common.Enable App Access") : t("common.Disable App Access")}</Grid>
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        open={info}
        sx={appAccessStyle}
        onClose={handleClose}
      >
        <DialogTitle>
          {props.enable ? t("common.Enable App Access") : t("common.Disable App Access")}
        </DialogTitle>
        <DialogContent sx={{lineHeight: '25px', color: 'gray', mt: 2}}>
          <Typography variant="body1" sx={{color: "#000"}}>
            {props.enable ? t('common.are you sure enable these employees app access?') : t('common.are you sure disable these employees app access?')}
          </Typography>
          <DialogActions>
            <LoadingButton
              id='ConfirmButton'
              loading={loading}
              sx={{textTransform: "capitalize"}}
              onClick={() => (changeEmployeeAccess())}
              variant={"contained"}>{t('common.confirm')}</LoadingButton>
            <Button id='CancelButton' sx={{textTransform: "capitalize"}}
                    onClick={handleClose}>{t('common.cancel')}</Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </Fragment>
  )
}

export default AppAccess;
